import { useEffect } from "react"

import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router"

import { userSetProp } from "../../../User/redux/user.actions"
import { adyenUploadFiles, getPaymentProcessors } from "../../../User/redux/user.thunks"

export const useUploadTransactions = ({ businessId, notification }) => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const { adyenFilesUploading } = useSelector((state) => state.user)

  useEffect(() => {
    dispatch(userSetProp({ key: "adyenFilesUploading", value: false }))
  }, [])

  const uploadFilesRequest = async (data) => {
    try {
      await dispatch(adyenUploadFiles(data)).unwrap()
      notification.success({ message: "Adyen data is uploaded successfully" })
      if (businessId)
        dispatch(
          getPaymentProcessors({
            integrationsPage: true,
            merchant_id: businessId,
            return_url: process.env.REACT_APP_BASE_URI + pathname
          })
        )
    } catch (e) {
      // The thunk rejects with the resolved message, so the old `e.message.detail`
      // unwrapping collapses to a plain string check.
      notification.error({
        message: typeof e === "string" ? e : "Failed to upload Adyen data"
      })
    }
  }

  const handleUploadFiles = (integration) => {
    const input = document.createElement("input")
    input.type = "file"
    input.accept = ".csv"
    input.multiple = true
    input.onchange = (e) => {
      const files = e.target.files
      if (files && files.length > 0) {
        const filesArray = Array.from(files)
        uploadFilesRequest({ files: filesArray, merchant_id: businessId })
      }
    }
    input.click()
  }

  return { handleUploadFiles, adyenFilesUploading }
}
